const Designer = () => {
  return (
    <div style={{ color: "white", position: "absolute", padding: 16, bottom: 0, right: 0 }}> 
      designed by <a href="https://dribbble.com/Volorf" target="_blank">Oleg Frolov</a> on <a href="https://dribbble.com/shots/5539678-Stepper-VI" target="_blank">Dribble</a>
    </div>
  )
}

export default Designer;